// extracted by mini-css-extract-plugin
module.exports = {"twoButtonsInRow":"_1yXZPT","xs":"_34lrqE","xsm":"_1a4R4F","sm":"_19fPR1","alignLeft":"_2MFfcx","alignRight":"_36l-Py","reversedOnDesktop":"_1SGFxE"};